import { random } from 'lodash';
import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

export const text = ({
	dictionary,
}: CreationContextFor<typeof COMPONENT_TYPE.TEXT>): CreatedBuildingBlock<typeof COMPONENT_TYPE.TEXT> =>
	createModel({
		type: COMPONENT_TYPE.TEXT,
		componentProps: {
			styles: {},
			other: {},
			[UNIFORM_PROPS.tag]: 'p',
		},
		children: {
			[COMPONENT_STATES.DEFAULT]: {
				[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: dictionary.TEXT[`text_${random(2)}`],
			},
		},
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.TEXT>;
